/**
 * Mobile Product Thumbnails - Simple Visible Arrows
 */
(function($) {
  'use strict';
  
  function initMobileThumbnails() {
    var $mobileThumbnails = $('[data-mobile-thumbnails]');
    
    if (!$mobileThumbnails.length) {
      return;
    }
    
    var isMobile = $(window).width() < 768;
    
    if (!isMobile) {
      return;
    }
    
    if ($mobileThumbnails.hasClass('slick-initialized')) {
      return;
    }
    
    // Initialize with simple text arrows
    $mobileThumbnails.slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      swipeToSlide: true,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><span>‹</span></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><span>›</span></button>'
    });
    
    // Click handler
    $mobileThumbnails.on('click', '[data-product-media-thumbnail-mobile]', function(e) {
      e.preventDefault();
      
      var $thumb = $(this);
      var mediaId = $thumb.data('media-id');
      
      $thumb.addClass('thumb-active')
        .closest('.product-detail__thumbnail-mobile')
        .siblings()
        .find('[data-product-media-thumbnail-mobile]')
        .removeClass('thumb-active');
      
      var $mainSlideshow = $('.product-detail__images');
      if ($mainSlideshow.hasClass('slick-slider')) {
        var $targetSlide = $('[data-product-media][data-media-id="' + mediaId + '"]');
        if ($targetSlide.length) {
          var slideIndex = $targetSlide.closest('.slick-slide').data('slick-index');
          $mainSlideshow.slick('slickGoTo', slideIndex);
        }
      }
    });
    
    // Sync with main slideshow
    var $mainSlideshow = $('.product-detail__images');
    if ($mainSlideshow.hasClass('slick-slider')) {
      $mainSlideshow.on('afterChange.mobileThumbs', function(evt, slick, currentSlide) {
        var $currentMedia = $('.product-media', slick.$slides[currentSlide]);
        var currentMediaId = $currentMedia.data('media-id');
        
        $('[data-product-media-thumbnail-mobile]')
          .removeClass('thumb-active')
          .filter('[data-media-id="' + currentMediaId + '"]')
          .addClass('thumb-active');
      });
    }
  }
  
  $(function() {
    setTimeout(function() {
      initMobileThumbnails();
    }, 500);
  });
  
  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      var $mobileThumbnails = $('[data-mobile-thumbnails]');
      var isMobile = $(window).width() < 768;
      
      if (isMobile && !$mobileThumbnails.hasClass('slick-initialized')) {
        initMobileThumbnails();
      } else if (!isMobile && $mobileThumbnails.hasClass('slick-initialized')) {
        $mobileThumbnails.slick('unslick');
        $('.product-detail__images').off('afterChange.mobileThumbs');
      }
    }, 250);
  });
  
})(jQuery);